import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

// RED ONES
var circleRedOne = document.querySelector('.circle--1');
var circleRedTwo = document.querySelector('.circle--2');



if (circleRedOne) {

  var movementone = gsap.timeline({
    scrollTrigger:{
      trigger: document.querySelector('.magazine--work-of-tomorrow .intro-text'),
      scrub: 1,
      start: 'top center',
      end:'bottom center',
    }
  })
  .to(circleRedOne, {
    x: '-100%',
    y: '100%',
  })
  var movementtwo = gsap.timeline({
    scrollTrigger:{
      trigger: document.querySelector('.magazine--work-of-tomorrow .circle__trigger--1'),
      scrub: 1,
      start: 'top center',
      end:'bottom center',
    }
  })
  .to(circleRedOne, {
    x: '-50%',
    y: '40%',
    opacity: 0
  })


  var movementwo = gsap.timeline({
    scrollTrigger:{
      trigger: document.querySelector('.magazine--work-of-tomorrow .intro-text'),
      scrub: 1,
      start: 'top center',
      end:'bottom center',
    }
  })
  .to(circleRedTwo, {
    x: '-90%',
    y: '0%',
  })
  var movementwo = gsap.timeline({
    scrollTrigger:{
      trigger: document.querySelector('.magazine--work-of-tomorrow .circle__trigger--1'),
      scrub: 1,
      start: 'top center',
      end:'bottom center',
    }
  })
  .to(circleRedTwo, {
    x: '+170%',
    y: '100%',
    opacity: 0
  })


  // BLUE ONES
    ScrollTrigger.create({
      trigger: document.querySelector('.magazine--work-of-tomorrow .circle__trigger--2'),
      start: "top 60%",
      end: "bottom 60%",
      onEnter: () => document.querySelector('.magazine--work-of-tomorrow').classList.add('circles--blue-active'),
      onLeave: () => document.querySelector('.magazine--work-of-tomorrow').classList.remove('circles--blue-active'),
      onEnterBack: () => document.querySelector('.magazine--work-of-tomorrow').classList.add('circles--blue-active'),
      onLeaveBack: () => document.querySelector('.magazine--work-of-tomorrow').classList.remove('circles--blue-active'),
    });



  // YELLOW
    ScrollTrigger.create({
      trigger: document.querySelector('.magazine--work-of-tomorrow .circle__trigger--3'),
      start: "top 60%",
      end: "bottom 60%",
      onEnter: () => document.querySelector('.magazine--work-of-tomorrow').classList.add('circles--yellow-active'),
      onLeave: () => document.querySelector('.magazine--work-of-tomorrow').classList.remove('circles--yellow-active'),
      onEnterBack: () => document.querySelector('.magazine--work-of-tomorrow').classList.add('circles--yellow-active'),
      onLeaveBack: () => document.querySelector('.magazine--work-of-tomorrow').classList.remove('circles--yellow-active'),
    });


  // GREEN
    ScrollTrigger.create({
      trigger: document.querySelector('.magazine--work-of-tomorrow .circle__trigger--4'),
      start: "top 60%",
      end: "bottom 60%",
      onEnter: () => document.querySelector('.magazine--work-of-tomorrow').classList.add('circles--green-active'),
      onLeave: () => document.querySelector('.magazine--work-of-tomorrow').classList.remove('circles--green-active'),
      onEnterBack: () => document.querySelector('.magazine--work-of-tomorrow').classList.add('circles--green-active'),
      onLeaveBack: () => document.querySelector('.magazine--work-of-tomorrow').classList.remove('circles--green-active'),
    });

}
